import * as types from 'actions/parental-lock/types';
import storage from 'helpers/storage';

const parentalData = JSON.parse(storage.get('parentalData'));

const data = {
  pin: null,
  purchase: parentalData && parentalData.purchase ? true : false,
  age: parentalData && parentalData.age ? parentalData.age : 'G',
  isParentalEnabled: parentalData && parentalData.isParentalEnabled ? true : false,
};

const initialState = {
  isLoading: false,
  data,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PIN:
      return { ...state, isLoading: true, error: null };
    case types.CHECK_PIN:
      return { ...state, isLoading: true, error: null };
    case types.CHECK_PIN_SUCCESS:
    case types.SET_PIN_SUCCESS:
      return { ...state, isLoading: false, data: { ...state.data, pin: action.payload } };
    case types.SET_PIN_ERROR:
    case types.CHECK_PIN_ERROR:
      return { ...state, error: action.payload };
    case types.SET_PURCHASE:
      storage.set('parentalData', JSON.stringify({ ...state.data, purchase: action.payload }));
      return { ...state, data: { ...state.data, purchase: action.payload } };
    case types.SET_AGE:
      storage.set('parentalData', JSON.stringify({ ...state.data, age: action.payload }));
      return { ...state, data: { ...state.data, age: action.payload } };
    case types.SET_ENABLED:
      storage.set(
        'parentalData',
        JSON.stringify({ ...state.data, isParentalEnabled: action.payload }),
      );
      return { ...state, data: { ...state.data, isParentalEnabled: action.payload } };
    default:
      return state;
  }
};
